import React from 'react';
import * as XLSX from 'xlsx';
import { Button } from '@mui/material';
import moment from 'moment';
import { dateExportFileFormat } from '../../../types/core/date.types';
interface Column {
  headerName: string;
  field: string;
}

interface Props {
  data: any;
  fileName: string;
  // výběr sloupců, které exportovat pokud undefined, exportuji všechny sloupce
  filterColumns?: Column[];
  buttonTitle?: string;
}

export function ExportXlsx({ data, fileName, filterColumns, buttonTitle = 'XLSX' }: Props) {
  const headers = filterColumns?.map((col: Column) => col.headerName);

  const getFileName = () => {
    // fileName_2022-09-09.xlsx
    let date = moment().format(dateExportFileFormat);
      return fileName + '_' + date + '.xlsx';
  };

  const downloadExcel = () => { 
    let rowData = data.map((row: any) => {
      delete row.tableData;
      return row;
    });
    // filtr na sloupce 
    if (filterColumns) {
      let filteredData = rowData.map((item: any) => {
        let tmpItem: any = {};
        filterColumns.map((col: Column) => {
          return (tmpItem[col.field] = item[col.field]);
        });
        return tmpItem;
      });
      rowData = filteredData;
    }

    const workSheet = XLSX.utils.json_to_sheet(rowData);
    // pokud jsou definovány headers, tak doplním, jinak se použijí názvy atributů
    if (headers && headers?.length > 0) XLSX.utils.sheet_add_aoa(workSheet, [headers]);
    const workBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, fileName);
    XLSX.write(workBook, { bookType: 'xlsx', type: 'binary' });
    // download
    XLSX.writeFile(workBook, getFileName());
  };

  return (
    <>
      <Button onClick={() => downloadExcel()} variant="text">
        {buttonTitle}
      </Button>
    </>
  );
}
